import '../styles.scss';
import React from 'react';
import Chart from 'react-apexcharts';
import { formatarMoeda } from 'util/numberUtil';
import SemDados from '../SemDados';

const MesInvestimento = (props) => {
  const { data } = props;
  const titulo = 'TOTAL INVESTIDO POR MÊS';

  if (!data || data.length < 1) {
    return <SemDados titulo={titulo} />;
  }

  const itensAnos = [];
  const itensMeses = [];
  // popula os arrays de anos e meses
  data.forEach((ano) => {
    itensAnos.push(ano.ano);
    ano.data.forEach((mes) => {
      itensMeses.push(mes);
    });
  });

  const itensValores = itensMeses.map((mes) => {
    return mes.totalCusto;
  });

  const series = [
    {
      name: 'Total Investmento',
      data: itensMeses.map((mes) => {
        return mes.totalCusto;
      }),
    },
  ];

  const maxValue = Math.max(...itensValores);

  const options = {
    colors: ['#7daee3', '#18327f'],
    legend: {
      showForSingleSeries: true,
      // formatter: (seriesName) => {
      //   return [seriesName.toUpperCase()];
      // },
      show: true,
      position: 'top',
      horizontalAlign: 'left',
      floating: true,
      offsetX: 0,
      offsetY: 6,
    },
    plotOptions: {
      bar: {
        hideZeroBarsWhenGrouped: false,
        horizontal: false,
        columnWidth: '70%',
        dataLabels: {
          position: 'top',
        },
        colors: {},
      },
    },
    stroke: {
      colors: ['transparent'],
      width: 4,
    },
    xaxis: {
      show: true,
      categories: itensMeses.map((mes) => {
        return mes.mes;
      }),
      group: {
        style: {
          fontSize: '12px',
          fontWeight: 700,
        },
        groups: data.map((ano) => {
          return {
            title: ano.ano,
            cols: ano.data.length,
          };
        }),
      },
      labels: {
        show: true,
        offsetY: 0,
        style: {
          fontWeight: 600,
        },
      },
      axisBorder: {
        show: true,
        color: '#a3a3a3',
      },
      axisTicks: {
        show: true,
        color: '#a3a3a3',
      },
    },
    yaxis: {
      max: maxValue * 1.2,
      show: false,
    },
    grid: {
      show: true,
      xaxis: {
        lines: {
          show: false,
        },
      },
      yaxis: {
        lines: {
          show: false,
        },
      },
    },
    chart: {
      parentHeightOffset: 5,
      toolbar: {
        show: true,
      },
    },
    dataLabels: {
      hideOverflowingLabels: false,
      textAnchor: 'middle',
      offsetX: 0,
      offsetY: -19,
      formatter: (value) => {
        return value === null ? formatarMoeda(0) : formatarMoeda(value);
      },
      style: {
        fontSize: '12px',
        fontWeight: 'bold',
        colors: ['#373d3f'],
      },
    },
    tooltip: {
      shared: false,
      followCursor: true,
      intersect: false,
      onDatasetHover: {
        highlightDataSeries: false,
      },
      // eslint-disable-next-line
      custom: ({ series, seriesIndex, dataPointIndex }) => {
        return `<div class="arrow_box">
            <span>
              Mes: <span id="data">${itensMeses[dataPointIndex].mes}</span>
            </span>
            <span>
              Ano: <span id="data">${itensMeses[dataPointIndex].ano}</span>
            </span>
            <span>
              Custo Total: <span id="data">R$${formatarMoeda(
                itensMeses[dataPointIndex].totalCusto
              )}</span>
            </span>
          </div>
          `;
      },
    },
  };

  return (
    <div className="grafico" style={{ overflow: 'hidden' }}>
      <div className="grafico-titulo">
        <span>{titulo}</span>
      </div>
      <div className="scrollable-horizontal">
        <Chart
          options={options}
          series={series}
          type="bar"
          height="250"
          style={{
            width: options.xaxis.categories.length * 100,
            minWidth: '100%',
          }}
        />
      </div>
    </div>
  );
};

export default MesInvestimento;
